import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { Message } from 'element-ui'
import { Route } from 'vue-router'
import { PermissionModule } from '@/store/modules/permission'
import i18n from '@/lang' // Internationalization
import settings from './settings'
import AuthService, {AuthCheck} from '@/services/auth_service';
import {AppModule} from "@/store/modules/app";
import ShareService from "@/services/share-service";
import { checkStorageAccess } from '@/utils/permission'

const auth_service = AuthService;

NProgress.configure({ showSpinner: true })

const whiteList = ['/login', '/auth-redirect', '/init_admin']

const getPageTitle = (key: string) => {
  const hasKey = i18n.te(`route.${key}`)
  if (hasKey) {
    const pageName = i18n.t(`route.${key}`)
    return `${pageName} - ${settings.title}`
  }
  return `${settings.title}`
}


// Функция проверки прав доступа к конструктору груповых объектов
const checkStorageAccessRoute = (to: Route): boolean => {
  if (to.meta && to.meta.checkStorageAccess) {
    const UserManagerService = require('@/services/data/user_manager').default;
    const access = UserManagerService.current_user.storage_access
    return access === 'read_and_edit' || access === 'read_only'
  }
  return true;
}



router.beforeEach(async(to: Route, _: Route, next: any) => {
  // Start progress bar
  NProgress.start()

  // Determine whether the user has logged in
  if (auth_service.getToken()) {

    if (to.path === '/login') {
      await auth_service.logout();
      auth_service.setFirstInit(true);
      next();
      NProgress.done()
    }

    else {
      // Проверка наличия сформированных роутов для пользователя
      if (auth_service.first_init) {
        if (AuthService.isActiveDirectoryAuth()) {
          const checkResult = await auth_service.checkLogged();
          if (checkResult.status === AuthCheck.INIT_ADMIN) {
            AuthService.resetToken();
            next(`/init_admin`);
          } else if (checkResult.status === AuthCheck.LOGIN) {
            AuthService.resetToken();
            await loginActiveDirectoryAccount();
            next({...to, replace: true});
          } else {
            // Ветка когда есть токен, и он валидный, проверка AD не требуется
            const role = auth_service.getRole();
            if (checkResult.heat_node_ids) {
              auth_service.setHeatNodeIds(checkResult.heat_node_ids)
            }
            PermissionModule.GenerateRoutes(role);
            await ShareService.loadAllCaches(true);
            router.addRoutes(PermissionModule.dynamicRoutes);
            next({...to, replace: true});
          }
          auth_service.setFirstInit(false);
          NProgress.done();
        } else {
          try {
            const role = auth_service.getRole();
            // Формирование списка роутов в соотвествии с ролью пользователя
            PermissionModule.GenerateRoutes(role);
            // Dynamically add accessible routes
            router.addRoutes(PermissionModule.dynamicRoutes);

            auth_service.setFirstInit(false);

            // Hack: ensure addRoutes is complete
            // Set the replace: true, so the navigation will not leave a history record
            next({...to, replace: true})
          } catch (err) {

            auth_service.resetToken();
            Message.error(err || 'Has Error');
            auth_service.setFirstInit(true);
            next(`/login`);
            next();
            NProgress.done()
          }
        }
      } else {
        // Проверяем права доступа к файловому менеджеру для уже загруженных роутов
        if (!checkStorageAccessRoute(to)) {
          Message.error('У вас нет доступа к файловому менеджеру');
          next('/');
          NProgress.done();
          return;
        }
        next()
      }
    }
  }
  else {
    // Has no token
    console.log('NO token present!!!')
    // @ts-ignore
    // отключение авторизации при разработке

    if (config.AUTH === 'false' || config.AUTH === false) {

      if (auth_service.first_init) {
        const role = 'admin';
        PermissionModule.GenerateRoutes(role);
        router.addRoutes(PermissionModule.dynamicRoutes);
        auth_service.setFirstInit(false);

        next({...to, replace: true})
        NProgress.done()
      }

      next();
      NProgress.done();

    } else {

      if (whiteList.indexOf(to.path) !== -1) {
        next();
      } else if (AuthService.isActiveDirectoryAuth()) {
        const checkResult = await auth_service.checkLogged();
        if (checkResult.status === AuthCheck.INIT_ADMIN) {
          next(`/init_admin`);
        } else {
          await loginActiveDirectoryAccount();
          next({...to, replace: true});
        }
        NProgress.done();
      } else {
        auth_service.setFirstInit(true);
        next('/login');
        NProgress.done()
      }
    }
  }
})

const loginActiveDirectoryAccount = async () => {
  ShareService.initializing = true;
  AppModule.SetAdLogin(true);
  let resp: any = await AuthService.login({login: 'login'}, 1100000);
  AppModule.SetAdLogin(false);
  if (resp.data) {
    AuthService.saveUserToken(resp.data);
    await ShareService.loadAllCaches();
    const role = auth_service.getRole();
    // Формирование списка роутов в соотвествии с ролью пользователя
    PermissionModule.GenerateRoutes(role);
    // Dynamically add accessible routes
    router.addRoutes(PermissionModule.dynamicRoutes);
    auth_service.setFirstInit(false);
  }
}

router.afterEach((to: Route) => {
  // Finish progress bar
  NProgress.done()
})
